import {
  departmentsQuery,
  useDeleteDepartmentMutation,
} from "@common/api/departments"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/departments/_list/$departmentId/delete",
)({
  component: DeleteDepartmentDialog,
})

function DeleteDepartmentDialog(): React.ReactElement | null {
  const { departmentId } = Route.useParams()
  const { data } = useSuspenseQuery(departmentsQuery())
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const deleteMutation = useDeleteDepartmentMutation()
  const department = data.data.find((item) => item.id === departmentId)

  if (!department) {
    return null
  }

  const close = () =>
    navigate({
      to: "/settings/workspace/departments/$departmentId",
      params: { departmentId },
      search: true,
    })

  const confirm = () =>
    deleteMutation.mutate(
      { department_id: departmentId },
      {
        onSuccess: () => {
          showToast("Archived", `${department.name} archived.`, "success")
          navigate({ to: "/settings/workspace/departments", search: true })
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Archive ${department.name}?`}
      description="This hides the department from active lists. You can restore it from the Archived tab."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={deleteMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
